import React from "react";
import { Link } from "react-router-dom";
import BookShelf from "../BookShelf/BookShelf";
import * as BooksAPI from "../../BooksAPI";
import MyTwitter from "../Twitter/Twitter";
class SearchPage extends React.Component {
  searchInputRef = React.createRef();
  state = { books: [] };

  doSearch = () => {
    setTimeout(() => this.bookSearch(), 500);
  };

  bookSearch = () => {
    let terms = this.searchInputRef.current.value.trim();
    if (terms.length === 0) {
      this.setState({ books: [] });
      return;
    }
    BooksAPI.search(terms).then((result) => {
      const { items } = result;
      terms = this.searchInputRef.current.value;
      if (items || terms.length === 0) {
        this.setState({ books: [] });
        return;
      }
      const books = result.sort((a, b) => (a.title > b.title ? 1 : -1));
      this.setState({ books: books });
    });
  };

  render() {
    return (
      <div className="search-books">
        <div className="search-books-bar">
          <Link to="/" className="close-search">
            Close
          </Link>
          <div className="search-books-input-wrapper">
            <input
              type="text"
              placeholder="Search by title or author"
              onChange={() => this.doSearch()}
              ref={this.searchInputRef}
            />
          </div>
        </div>
        <div className="search-books-results">
          <BookShelf shelfname="" books={this.state.books} />
          <MyTwitter />
        </div>
      </div>
    );
  }
}

export default SearchPage;
